import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';

import AuthService from "services/API/Auth/AuthService";
import ERService from 'services/API/ExpoRichieste/ExpoRichiesteService.js';

// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDButton from "common/components/MD/MDButton";
import MDInput from "common/components/MD/MDInput";
import MDTypography from "common/components/MD/MDTypography";
import DashboardLayout from "layouts/DashboardLayout";
import Footer from "layouts/components/Footer";
import HeaderForm from "layouts/components/HeaderForm";
import DashboardNavbar from "layouts/components/Navbars/DashboardNavbar";
// @mui material components
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import Grid from "@mui/material/Grid";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import ExpoRichiesteStepper from "pages/riservata/expo_richieste/ExpoRichiesteStepper";
import ExpoRichiesteVis from "pages/riservata/expo_richieste/ExpoRichiesteVis";



//validazione lato client
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

//script
import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";
import { Alert } from "@mui/material";
import ExpoRichiesteTipologiaVis from "../expo_richieste_admin/ExpoRichiesteTipologiaVis";
import { useMaterialUIController } from "common/context";
import { useFarFieraUIController } from "common/context/FarFieraContext";
import SectionTitle from "common/components/mycomponents/SectionTitle";
import brandButtonSx from "common/assets/theme/components/brandButtonSx";
import { brandButtonOutlinedSx } from "common/assets/theme/components/brandButtonSx";
import { brandAnnullaButtonSx } from "common/assets/theme/components/brandButtonSx";

const ExpoRichiestaConfirm = () => {

    const location = useLocation();
    const navigate = useNavigate();
  const [ffcontroller] = useFarFieraUIController();
  const { manifestazione} = ffcontroller;


    const { modo, soggetto, subject } = location.state;
    const [tot_10, setTot_10] = useState(0);
    const [tot_11, setTot_11] = useState(0);
    const [tot_12, setTot_12] = useState(0);
    const [tot_13, setTot_13] = useState(0);
    // user state for form
    const [prop, setProp] = useState({
        idRichiesta: 0,avi:false,
        id_utente: AuthService.getCurrentUser().id,
        manifestazione: subject,
        ragione_sociale: '',
        rappresentante_legale: '', indirizzo: '', civico: '', cap: '', localita: '', indirizzo2: '', provincia: '',
        piva: '', cf: '', telefono: '', fax: '', www: '', email: '', pec: '', iban: '', codice_sdi: '',
        cm_code_01: '', cm_desc_01: '', cm_code_02: '', cm_desc_02: '', cm_code_03: '', cm_desc_03: '', cm_code_04: '', cm_desc_04: '',
        responsabile_fiera: '', responsabile_fiera_telefono: '', responsabile_fiera_cell: '', responsabile_fiera_email: '',
        prodotti_servizi: '', produttore: false, concessionario: false, distributore: false, rivenditore: false, importatore: false,
        tipologia_espositiva_scelta: '', note: '', specie_quantita:'',
        q_10: 0, q_11: 0, q_12: 0, q_13: 0,q_avi:0, importo_area: 0, imponibile: 450, iva: 450 * 0.22, totale: 488, anticipo_versato: 120
    });



    /* ----------------------------CARICAMENTO E RIEMPIMENTO CAMPI------------------------------------------------- */

    useEffect(() => {
        if (soggetto != null) {
            console.log("soggetto non nullo: id=" + soggetto.idRichiesta);
            seleziona_soggetto();
        } else {
            console.log("soggetto nullo");
        }
    }, [soggetto]);

    async function seleziona_soggetto() {
        console.log("Cambiata pp->seleziono i dettagli :" + soggetto.idRichiesta);
        if (soggetto.idRichiesta !== 0) {
            const response = await ERService.seleziona(soggetto.idRichiesta);
            response.errors ? console.log(response.errors) : retrive(response.data);
        }
    }




    function retrive(data) {
        console.log(data);
        setProp({
            idRichiesta: data.idRichiesta,
            avi:data.avi,
            id_utente: data.id_utente,
            manifestazione: data.manifestazione,
            ragione_sociale: data.ragione_sociale,
            rappresentante_legale: data.rappresentante_legale,
            indirizzo: data.indirizzo,
            civico: data.civico,
            cap: data.cap,
            localita: data.localita,
            provincia: data.provincia,
            indirizzo2: data.indirizzo2,
            cf: data.cf,
            piva: data.piva,
            telefono: data.telefono,
            fax: data.fax,
            email: data.email,
            www: data.www,
            pec: data.pec,
            isEstero: data.estero,
            iban: data.iban,
            iban2: data.iban2,
            swift: data.swift,
            codice_sdi: data.codice_sdi,
            cm_01: data.cm_01,
            cm_02: data.cm_02,
            cm_03: data.cm_03,
            cm_04: data.cm_04,
            cm_01_descrizione: data.cm_01_descrizione,
            cm_02_descrizione: data.cm_02_descrizione,
            cm_03_descrizione: data.cm_03_descrizione,
            cm_04_descrizione: data.cm_04_descrizione,
            responsabile_fiera: data.responsabile_fiera,
            responsabile_fiera_telefono: data.responsabile_fiera_telefono,
            responsabile_fiera_cell: data.responsabile_fiera_cell,
            responsabile_fiera_email: data.responsabile_fiera_email,
            prodotti_servizi: data.prodotti_servizi,
            produttore: data.produttore,
            concessionario: data.concessionario,
            distributore: data.distributore,
            rivenditore: data.rivenditore,
            importatore: data.importatore,
            tipologia_espositiva_scelta: data.tipologia_espositiva_scelta,specie_quanti:data.specie_quanti,
            q_10: data.q_10, q_11: data.q_11, q_12: data.q_12, q_13: data.q_13,q_avi:data.q_avi,
            importo_area: data.importo_area, imponibile: data.imponibile, iva: data.iva,
            totale: data.totale, anticipo_versato: data.anticipo_versato,
            note: data.note, esigenze_espositive: data.esigenze_espositive,

        });

        //     console.log(prop.q_13 );
        //   console.log(data.q_13 );
        setTot_10(data.q_10 * 75);
        setTot_11(data.q_11 * 80);
        setTot_12(data.q_12 * 1800);
        setTot_13(data.q_13 * 1000);
        // console.log(tot_13);
        console.log("selezionata  " + prop.idRichiesta);

    }


    /* ---------------------------------pdf---------------------------------------------------------------------*/



    async function download_pdf() {
        console.log("download_pdf :" + soggetto.idRichiesta);
        if (soggetto.idRichiesta !== 0) {

            const anno=manifestazione.replace(" ","");
            let filename ="PropostaDiPartecipazione"+ anno+".pdf";

            if(prop.avi){
                 filename ="PropostaDiPartecipazioneAvi"+ anno+".pdf";

            }

            ERService.download_pdf(soggetto.idRichiesta)
                .then(response => {
             
                    return response.data;
                })
                .then(blob => {

                    var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
                    var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
                    var url = URL.createObjectURL(blobb);
                    var a = document.createElement('a');
                    a.href = url;
                    a.target = "_blank";
                    a.download = filename;
                    document.body.appendChild(a); // append the element to the dom
                    a.click();
                    a.remove(); // afterwards, remove the element  
                })
                .catch(error => {
                    console.error(error);
                });

            /*           let filename = 'StampaRichiesta.pdf';
                       var url=    ERService.download_pdf(soggetto.idRichiesta);
           
                             var a = document.createElement('a');
                             a.href = url;
                             a.target = "_blank";
                             a.download = filename;
                             document.body.appendChild(a); // append the element to the dom
                             a.click();
                             a.remove();*/

        }
    }



    /* ----------------------------VALIDAZIONE E SALVATAGGIO----------------------------------------------------------------------- */


    const validationSchema = Yup.object().shape({
        pdf_proposta: Yup.mixed()
            .required("Devi caricare un file")
            .test("fileSize", "Il file è troppo grande o non c'è!", (file) => {
                //if u want to allow only certain file sizes
                return file && file[0] && file[0].size <= 2000000;
            })

    });



    /* ----------------------------SALVATAGGIO E REGISTRAZIONE------------------------------------------------- */



    const {
        register, //register inputs
        reset, setValue, control,
        handleSubmit,//handle form submit
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });



    const [submitted, setSubmitted] = useState(false);


    const [error, setError] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);



    const inserisci_pp = (formData) => {
        if (AuthService.isTokenOk()) {
        setError(null);

        var data = {
            idRichiesta: prop.idRichiesta,
            id_utente: AuthService.getCurrentUser().id,
            manifestazione: prop.manifestazione,
            pdf_proposta: formData.pdf_proposta,


        };

        if (modo === 'edit') {
            ERService.invia(prop.idRichiesta, data)
                .then(response => {
                    handleResponse(response, 'SENT');
                })
                .catch(errore => {
                    handleError(errore);
                });
        }
    }

    }

    function handleResponse(response, op) {
        console.log(response.data);
        setSubmitted(true);

        navigate("/expo_richieste", { state: { submitted: true, salvato: op } });
    }


    function handleError(error) {
        setError(error);
        console.log("ERRORE" + error);
        console.log(error.code);

        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log("ERROR:RESPONSE" + error.response.data);
            setErrorMessage(error.response.data);

        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log("EEROR:REQUEST" + error.request);
            setErrorMessage(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
            setErrorMessage(error.message);
        }

    }

    const [open, setOpen] = useState(false);
    const [openExistent, setOpenExistent] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [confirmExistent, setConfirmExistent] = useState(false);


    function handleClose() {
        setOpen(false);
    }

    function handleConfirm() {
        setConfirm(true);
        setOpen(false);
        deleteAnag();
    }


    const handleOpen = () => {
        console.log("OPEN DIALOG");
        setOpen(true);
    }

    function handleCloseExistent() {
        setOpenExistent(false);
    }

    function handleConfirmExistent() {
        setConfirmExistent(true);
        setOpenExistent(false);

    }

    const deleteAnag = () => {
        if (AuthService.isTokenOk()) {
        setError(null);

        if (modo === 'edit') {

            console.log("delete anag");

            ERService.remove(prop.idRichiesta)
                .then(response => {
                    console.log("handleResponse");
                    handleResponse(response, 'DEL');
                })
                .catch(errore => {
                    console.log("handleError");
                    handleError(errore);
                });

        }}
    };


    /* ------------------------------navigazione -----------------------------------------------------------------*/


    const annulla = () => {


        navigate("/expo_richieste");
    }



    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
                    <DialogTitle id="alert-dialog-title">
                        Eliminare questo record?
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Sei sicuro di voler eliminare questa proposta di partecipazione?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <MDButton onClick={handleClose}>No</MDButton>
                        <MDButton onClick={handleConfirm} autoFocus>
                            SI
                        </MDButton>
                    </DialogActions>
                </Dialog>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card >
                            <HeaderForm titolo={"Proposta di Partecipazione " + prop.manifestazione} modo='edit' save={handleSubmit(inserisci_pp)} exit={annulla} remove={handleOpen} />
                            {error !== null &&
                                    <Alert color="error"><ErrorOutlineOutlinedIcon fontSize="small" />&nbsp;{errorMessage}</Alert>
                                }
                            
                            <MDBox pt={1} pb={3} px={3} component="form" role="form">
                                <CardContent>
                                    <MDBox>
                                        <MDBox opacity={1} textAlign="center">

                                        </MDBox>
                                        <MDBox pt={4} pb={3} px={3} >
                                            <MDBox>
                                                <ExpoRichiesteStepper index_attivo={2} />
                                            </MDBox>
                                            <MDBox mt={5}>


                                                <ExpoRichiesteVis prop={prop}></ExpoRichiesteVis>
                                                


                                    
                                                <MDBox mt={5} mb={4}>
                                                    <SectionTitle title="TIPOLOGIA ESPOSITIVA SCELTA"></SectionTitle>
                                                </MDBox>
                                                
                                                <ExpoRichiesteTipologiaVis prop={prop} tot_10={tot_10} tot_11={tot_11}
                                                            tot_12={tot_12} tot_13={tot_13}></ExpoRichiesteTipologiaVis> 

                                                <MDBox mb={2}>
                                                </MDBox>



                                                <MDBox sx={{ display: 'flex', flexDirection: 'row', pt: 2 }} mt={4} mb={1}>

                                                    <MDTypography variant="h5" fontWeight="bold" >Scarica e stampa la Proposta. Timbra e firma il documento e ricaricalo tramite il pulsante seguente! </MDTypography>
                                                    <MDBox sx={{ flex: '1 1 auto' }} />
                                                    <MDBox ml={2}>

                                                        <MDButton sx={brandButtonOutlinedSx} onClick={download_pdf}  >
                                                            Scarica il pdf
                                                        </MDButton>
                                                    </MDBox>

                                                </MDBox>
                                                <MDBox mb={2}>
                                                </MDBox>
                                                <MDBox>


                                                    <MDInput
                                                        type="file"
                                                        label="Proposta di partecipazione" fullWidth required
                                                        autocomplete="off"  {...register('pdf_proposta')}
                                                        name="pdf_proposta" InputLabelProps={{ shrink: true }}

                                                    />
                                                    <MDTypography
                                                        variant="button"
                                                        fontWeight="regular"
                                                        color="text"
                                                        sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                                                    >
                                                        {prop.nome_pdf_proposta}
                                                    </MDTypography>

                                                    {
                                                        errors.pdf_proposta ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.pdf_proposta?.message}</span> : ''
                                                    }
                                                </MDBox>

                                                {error !== null &&
                                    <Alert color="error"><ErrorOutlineOutlinedIcon fontSize="small" />&nbsp;{errorMessage}</Alert>
                                }
                                                <MDBox sx={{ display: 'flex', flexDirection: 'row', pt: 2 }} mt={4} mb={1}>
                                                    <MDButton variant="outlined" sx={brandAnnullaButtonSx} onClick={annulla} >
                                                        annulla
                                                    </MDButton>
                                                    <MDBox sx={{ flex: '1 1 auto' }} />

                                                    <MDBox ml={2}>
                                                        <MDButton variant="outlined" sx={brandButtonOutlinedSx} onClick={handleSubmit(inserisci_pp)} type="submit"  >
                                                            INVIA
                                                        </MDButton>
                                                    </MDBox>

                                                </MDBox>

                                            </MDBox>
                                        </MDBox>
                                    </MDBox>
                                </CardContent>
                            </MDBox>
                        </Card>
                    </Grid></Grid></MDBox>
        </DashboardLayout>
    )
}


export default ExpoRichiestaConfirm;